/*
 * Layout for campaign launch area
 */

define([
  "marionette",
  "jquery",
  "./template/campaignLaunchTemplate.html",
  "jquery-ui",
  "jquery-ui/ui/widgets/datepicker",
], function (Marionette, $, CampaignLaunchTemplate) {
  const CampaignView = {};

  CampaignView.campaignLaunchView = Marionette.ItemView.extend({
    template: CampaignLaunchTemplate,
    events: {
      "click #scheduleCampaign": function () {
        //use event instead of trigger to avoid blocking the propogation of this event
        //if we are opening the change status menu, trigger the event and generate menu listing
        if (!this.ui.campaignScheduleStatusDropdown.hasClass("open")) {
          //since the menu will show up even if we don't want it to, hide it until we are sure we want to show the menu
          this.ui.campaignScheduleStatusDropdownMenu.addClass("hidden");
          this.trigger("open:campaign:schedule:status:menu");
        }
      },
    },
    triggers: {
      "click #publishOrEnableButton": "publish:or:enable:now",
      "click #disableButton": "disable:now",
      "click #cancelScheduleButton": "cancel:schedule",
    },
    ui: {
      campaignScheduleStatusDropdown: ".campaign-schedule-status-dropdown",
      campaignScheduleStatusDropdownMenu: ".campaign-schedule-status-dropdown-menu",
    },
    onDomRefresh: function () {
      $("#campaignScheduleDatepicker").datepicker();
    },
    setStatusMenu: function (statuses) {
      this.ui.campaignScheduleStatusDropdownMenu.html("");
      for (const [targetStatusId, translation] of statuses) {
        this._addDropdownMenuItem(
          this.ui.campaignScheduleStatusDropdown,
          this.ui.campaignScheduleStatusDropdownMenu,
          targetStatusId,
          translation,
          () => this.trigger("open:campaign:schedule:modal", targetStatusId),
        );
      }
      this.ui.campaignScheduleStatusDropdownMenu.removeClass("hidden");
    },
    scheduleError: function (errorMessage) {
      this.$el
        .find("#scheduleError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    _addDropdownMenuItem: function (dropdownEl, dropdownMenuEl, id, data_i18n, callback) {
      const htmlItem = this._buildDropdownMenuItem(id, data_i18n);
      dropdownMenuEl.append(htmlItem);
      dropdownMenuEl.find(`#${id}`).one("click", () => {
        //close menu
        dropdownEl.removeClass("open");
        callback.call(this);
        return false;
      });
    },
    _buildDropdownMenuItem: function (id, data_i18n) {
      const data = $.t(data_i18n);
      return `<li id="${id}"><a>${data}</a></li>`;
    },
  });

  return CampaignView;
});
